import "@fortawesome/fontawesome-free/css/all.min.css";
import classNames from "classnames";
import React from "react";
import styles from "./fa-icon.module.less";
export var Icon = function Icon(_ref) {
  var brand = _ref.brand,
      className = _ref.className,
      name = _ref.name,
      title = _ref.title;
  var classes = classNames(styles.icon, className, "fa", "fa-".concat(name), brand && "fa-brands");
  return /*#__PURE__*/React.createElement("i", {
    className: classes,
    title: title
  });
};